/* eslint-disable react-hooks/exhaustive-deps */
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { BiPlus } from "react-icons/bi";
import { FaEye } from "react-icons/fa";
import AppButton from "../../common/AppButton";
import AppModal from "../../common/AppModal";
import Table from "../../common/Table";
import Body from "../../components/Body";
import TableMenu from "../../components/TableMenu";
import useHeader from "../../hooks/useHeader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getContracts } from "../../stores/ContractStore";
import { useQuery } from "@tanstack/react-query";
import { getOrganizations } from "../../stores/OrganizationStore";
const header = [
  { name: "contractId", title: "Contract ID", filter: "Search" },
  { name: "start", title: "Start" },
  { name: "end", title: "End" },
];

function Contracts() {
  const location = useLocation();
  const [init, setInit] = useState(location.state?.data);
  const { setHeader } = useHeader();
  const navigate = useNavigate();
  const [contracts, setContracts] = useState([]);
  const [model, setModel] = useState({});
  const params = useParams();

  const { data: contractsData } = useQuery({
    queryFn: () => getContracts(),
    queryKey: ["contracts"],
  });

  useEffect(() => {
    if (contractsData) {
      const data = contractsData.filter(
        (item) => item.organization === init._id
      );
      setContracts(data);
    }
  }, [contractsData]);

  const { data: organizations } = useQuery({
    queryFn: () => getOrganizations(),
    queryKey: ["organizations"],
  });

  const handleCreateContract = () => {
    navigate(
      `/organizations/contracts/${params.organization_id}/createContract`,
      {
        state: { data: cloneDeep(init) },
      }
    );
  };

  useEffect(() => {
    setHeader(init?.name);
  }, []);

  const data = contracts?.map((i) => ({
    ...i,
    organization: organizations?.find((item) => item._id === i.organization),
    client: organizations?.find((item) => item._id === i.organization)?.name,
    start: moment(i.contractStartDate).format("DD/MM/YYYY"),
    end: moment(i.contractEndDate).format("DD/MM/YYYY"),
  }));

  const onContractClick = (contract) => {
    navigate(
      `/organizations/view/${params.organization_id}/contract/${contract._id}`,
      { state: { data: cloneDeep(contract) } }
    );
  };

  return (
    <Body noPadding>
      <div style={{ width: "100%" }}>
        <TableMenu>
          <AppButton
            tooltip="Create Contract"
            onClick={handleCreateContract}
            leftIcon={<BiPlus size={35} />}
            className="btn"
          />
        </TableMenu>

        <Table
          loading={!data}
          header={header}
          data={data}
          SideButtons={({ inv }) => {
            return (
              <div className="side-button" style={{ marginRight: 20 }}>
                <AppButton
                  tooltip="View"
                  onClick={() => onContractClick(inv)}
                  leftIcon={<FaEye size={22} />}
                  className="text-primary btn-light"
                />
              </div>
            );
          }}
        />
        <AppModal
          {...model}
          onHide={() => {
            setModel({});
          }}
        />
      </div>
    </Body>
  );
}
export default observer(Contracts);
